import { simpleHash } from '@helpers/hash-string/hash-string';
import type { GridItemProps } from '@royalaholddelhaize/design-system-pantry-web/components/layout/grid/grid.interfaces';
import pkg from '../../package.json';

export const BASE_ROUTE_PATH = '/klantenservice';
export const CHECKIN_BASE_ROUTE_PATH = '/kies-een-moment';

export const CONTAINER_MAX_WIDTH = '1488px';

export const WIDE_GRID_ITEM_PROPS: GridItemProps = {
    xs: 4,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 12,
};

export const NARROW_GRID_ITEM_PROPS: GridItemProps = {
    xs: 4,
    sm: 4,
    md: 6,
    lg: 6,
    xl: 6,
};

export const FORM_GRID_ITEM_PROPS: GridItemProps = {
    xs: 4,
    sm: 4,
    md: 6,
    lg: 6,
    xl: 4,
};

export const FORM_MAX_WIDTH = '524px';

export const PAGINATION_SIZE = 10;

export const ROUTE_PATHS = {
    HOME: '/',
    CUSTOMER_SERVICE: BASE_ROUTE_PATH,
    FEEDBACK: `${BASE_ROUTE_PATH}/feedback`,
    FEEDBACK_CUSTOMER_SATISFACTION: `${BASE_ROUTE_PATH}/feedback/customer-satisfaction`,
    FEEDBACK_CUSTOMER_EFFORT: `${BASE_ROUTE_PATH}/feedback/customer-effort`,
    FEDBACK_CUSTOMER_INTERACTION: `${BASE_ROUTE_PATH}/feedback/customer-interaction`,
    FEEDBACK_CUSTOMER_CONTENT: `${BASE_ROUTE_PATH}/feedback/customer-content`,
    PRODUCT_RETURN: `${BASE_ROUTE_PATH}/retour`,
    DEPOSIT_COMPLAINT: `${BASE_ROUTE_PATH}/statiegeld`,
    PRODUCT_COMPLAINT_FORM_STORE: `${BASE_ROUTE_PATH}/productklacht/winkel`,
    PRODUCT_COMPLAINT_FORM_ONLINE: `${BASE_ROUTE_PATH}/productklacht/bestelling`,
    COMPLAINT_PAGE_NL: `${BASE_ROUTE_PATH}/iets-mis-met-bestelling`,
    COMPLAINT_PAGE_BE: `${BASE_ROUTE_PATH}/iets-mis-met-reservering`,
    PRODUCT_COMPLAINT: `${BASE_ROUTE_PATH}/productklacht`,
    MESSENGER: `${BASE_ROUTE_PATH}/messenger`,
    SEARCH: `${BASE_ROUTE_PATH}/zoeken`,
    SETTLEMENTS: `${BASE_ROUTE_PATH}/mijnverrekeningen`,
    // EVALUE_SETTLEMENTS: `/mijntegoed/transacties`,
};

export const protectedPaths = [
    ROUTE_PATHS.PRODUCT_COMPLAINT_FORM_STORE,
    ROUTE_PATHS.PRODUCT_COMPLAINT_FORM_ONLINE,
    ROUTE_PATHS.PRODUCT_RETURN,
    ROUTE_PATHS.SETTLEMENTS,
    ROUTE_PATHS.DEPOSIT_COMPLAINT,
];

export interface PathGuardPathConfig {
    redirectTo: string;
    check: {
        params: string[];
    };
    useInitParam?: boolean;
}

export interface PathGuardConfig {
    [key: string]: PathGuardPathConfig;
}

export const GUARDED_PATH_INIT_PARAM = 'v';
export const GUARDED_PATH_INIT_PARAM_VALUE = simpleHash(pkg.version);

export const guardConfig: PathGuardConfig = {
    [ROUTE_PATHS.FEEDBACK_CUSTOMER_CONTENT]: {
        redirectTo: BASE_ROUTE_PATH,
        check: {
            params: ['topic'],
        },
        useInitParam: true,
    },
    [ROUTE_PATHS.FEEDBACK_CUSTOMER_EFFORT]: {
        redirectTo: BASE_ROUTE_PATH,
        check: {
            params: ['type', 'topic'],
        },
        useInitParam: true,
    },
    [ROUTE_PATHS.FEDBACK_CUSTOMER_INTERACTION]: {
        redirectTo: BASE_ROUTE_PATH,
        check: {
            params: ['topic'],
        },
        useInitParam: true,
    },
    [ROUTE_PATHS.FEEDBACK_CUSTOMER_SATISFACTION]: {
        redirectTo: BASE_ROUTE_PATH,
        check: {
            params: ['shoppingType'],
        },
        useInitParam: true,
    },
};
